import { z } from 'zod';

/**
 * The task-specific WRITE contract for the review edit flow. The generic
 * mini-apps edit endpoint carries these opaquely in `extras` (the shared
 * `ReviewEdit` stays coding-only — framework code never learns task fields);
 * the clinical-tasks agent validates against this schema server-side, and the
 * edit sheet builds its payload from the same definition.
 *
 * Semantics per field: `undefined`/omitted = leave untouched; explicit `null`
 * clears (due date only — priority/owner are never cleared).
 */
export const clinicalTaskEditExtrasSchema = z.object({
  /** ISO date (YYYY-MM-DD); null removes the due date. */
  dueDate: z.string().nullable().optional(),
  /** Assignee, `Practitioner/<id>`. */
  ownerReference: z.string().nullable().optional(),
  /** FHIR request-priority code (see CLINICAL_TASK_PRIORITIES). */
  priority: z.string().nullable().optional(),
});

export type ClinicalTaskEditExtras = z.infer<
  typeof clinicalTaskEditExtrasSchema
>;
